import {
  MutateFunction,
  useMutation,
  UseMutationOptions,
} from "@tanstack/react-query";
import { FirstParameter, SecondParameter } from "@/openapi/types";
import type request from "@/openapi/request";
import { postAgreement } from "@/openapi/baob/SupplyPayee";

export const useSupplyPayeeControllerPostAgreement = (options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAgreement>>,
    Error,
    FirstParameter<typeof postAgreement>
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationFn: MutateFunction<
    Awaited<ReturnType<typeof postAgreement>>,
    Error,
    FirstParameter<typeof postAgreement>
  > = (params: FirstParameter<typeof postAgreement>) => {
    return postAgreement(params, options?.request);
  };

  return useMutation({ mutationFn, ...options?.mutation });
};
